module.exports = __webpack_public_path__ + "img/download-3d.0ab8d487.svg";